import { useDataFormStore } from "@/stores/form";
import { getArrayOfRules } from "@/utils/getDataForm";
import { ref } from "vue";

export default {
  props: {
    cities: Array,
  },

  setup() {
    const dataForm = useDataFormStore();

    const notificationError = ref(false);

    return {
      dataForm,
      notificationError,
      getArrayOfRules,
    };
  },
};
